module.exports = __webpack_public_path__ + "static/media/carta_75.7304bdf9.jpg";